namespace distill.dashboards.views.index {

    class InitArgs {
        dashboardsIndex: string = appn.emptyString;
    }

    let _initArgs: InitArgs;
    let _dataTable: any;
    let _selectedItems: any;

    export function init(args: InitArgs) {
        _initArgs = args;

        appn.folderFilter.init(_initArgs.dashboardsIndex);

        createDataTable();
        addEvents();
    }

    function addEvents() {
        $('#manageBtn').on('click', function (e: Event) {
            appn.dialog.showLoading();
        });
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sAjaxSource: 'Dashboards/DataTable',
            fnServerData: function (data: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked')),
                    { name: 'sCustom_1', value: appn.folderFilter.getStateOrDefault().value },
                    appn.dataTable.getStateOrDefault('sCustom_2', $('#sCustom_2').val()));
            },
            aaSorting: [[1, 'asc']],
            autoWidth: false,
            aoColumns: [
                { bSortable: false, sWidth: '3%' }, // checkbox
                { bSortable: true, sWidth: '39%' }, // name
                { bSortable: true, sWidth: '9%' }, // status
                { bSortable: true, sWidth: '4%' }, // version
                { bSortable: true, sWidth: '19%' }, // externalid
                { bSortable: true, sWidth: '13%' }, // lastupdated
                { bSortable: true, sWidth: '13%' } // lastupdatedby
            ],
            fnInitComplete: function () {

                // Inject Dashboard Action buttons
                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'organiseBtn', buttonType: 'Organise', isDataTableToggleBtn: true },
                    { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true },
                ], appn.requestUser.isUserOrHigher, true);

                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'addnew', buttonType: 'AddNew' }
                ], appn.requestUser.isUserOrHigher);

                appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));

                $('#addnew').click(function () {
                    appn.iframe.openModal({ url: 'Dashboards/Create?folderId=%0%'.replace('%0%', appn.folderFilter.selectedFolderId as string) });
                });

                // Bind organise button
                $('#organiseBtn').click(function () {
                    appn.folderFilter.showDialog($(this), appn.strings.organiseScreens);
                });

                // Bind manage tasks button
                $('#manageBtn').on('click', function (this, e: Event) {
                    e.preventDefault();
                    if ($(this as any).css('opacity') === '1') {
                        // Set selectedItems
                        _selectedItems = $('.selectRow:checked');

                        let dashboards = appn.emptyString;
                        _selectedItems.each(function (index: number, selected: JQuery<HTMLElement>) {
                            const row = selected.closest('tr');
                            const columns = $(row).find('td');

                            dashboards += `${$(selected).attr('id')},`;
                        });

                        $('#dashboardsToManage').val(dashboards);
                        $('#manageDashboardsDialog').modal('show');

                        const submitButton = $('#manageDashboardsDialog .card-header button[value="Manage_Trash"].btn-tool-danger');
                        appn.trash.createTrashMessageFromTable(submitButton, _selectedItems, T('Dashboards'));
                    }
                });

                $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(appn.strings.showArchived, 'saveMeState', 'sCustom_0'));

                appn.dataTable.addSearchPlaceholder(T('Filter results where Dashboard <b>Title, External Id or Status</b> contains a keyword typed in here.'));

                appn.saveMeState.init(function () {
                    _dataTable.fnDraw(false);
                },
                    function () {
                        _dataTable.fnDraw(false);
                    }, '.dataTables_filter');
            }
        });
    }
}
